import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { AtividadeGeral } from "../../../../types";

interface GetMembrosProps {

}


type ResponseMembrosCheckin = {
  listAll: AtividadeGeral[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: AtividadeGeral[]
  pagina: number
}

const GetAtividadeList = (): ResponseMembrosCheckin => {

  const [listMinisterioGrupo, setMinisterioGrupo] = useState<AtividadeGeral[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<AtividadeGeral[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = (params: any) => {
    api.get<AtividadeGeral[]>('atividade/geral', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setMinisterioGrupo(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {

          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<AtividadeGeral[]>('atividade/geral')
      .then(
        (sucesso) => {
          setMinisterioGrupo(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {

          console.log(error?.response);
        }
      )
  }, [resetar]);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listMinisterioGrupo,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams
  };
}

export default GetAtividadeList;
